import React, { useMemo, useState, ChangeEvent } from 'react';
import { Box, Flex, Icon, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuList } from '@chakra-ui/react';
import { CustomRenderers, ICustomListData } from 'pages/ListManagement/types';
import { MdExpandMore, MdOutlineSearch } from 'react-icons/md';
import { useTranslation } from 'helpers/languages/translations';

const CustomDropboxRenderer = ({ ...props }: CustomRenderers) => {
    const [inputValue, setInputValue] = useState<string>();
    const translate = useTranslation();
    const [filteredOptions, setFilteredOptions] = useState(props.customList);
    props.TD.className = props.cellProperties.valid === false && 'invalid';

    const handleChange = (retailer: ICustomListData) => {
        props.hotInstance.current.__hotInstance.setDataAtCell(props.row, props.col, retailer.id);
    };

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const inValue = e.target.value;

        setInputValue(inValue);
        const newFilteredOptions =
            props.customList &&
            props.customList.filter((option) => option.name.toLowerCase().includes(inValue.toLowerCase()));

        setFilteredOptions(newFilteredOptions);
    };

    const selectedRetailer = useMemo(() => {
        return props.customList && props.customList.find((item) => item.id === props.value)?.name;
    }, [props.value]);

    return (
        <Menu matchWidth={true} isLazy>
            <MenuButton fontSize="sm" px={0} height={5} alignItems="center" fontWeight={'semibold'} width={'100%'}>
                <Flex
                    backgroundColor={props.cellProperties.valid === false ? '#ffbeba!important' : ''}
                    fontWeight="normal"
                    minWidth="100%"
                    justifyContent="space-between"
                >
                    {props.cellProperties.valid === false ? translate('retailer.notfound') : selectedRetailer}
                    <Icon as={MdExpandMore} verticalAlign="middle" width="20px" height="20px" />
                </Flex>
            </MenuButton>
            <MenuList zIndex={100} maxH={200} overflow="auto">
                <InputGroup size="sm" mb={2} bg="white">
                    <InputLeftElement
                        pl="2"
                        pointerEvents="none"
                        children={<Icon as={MdOutlineSearch} boxSize={5} verticalAlign="middle" color="gray.300" />}
                    />
                    <Input
                        borderRadius="md"
                        data-testid={`search-input`}
                        placeholder={'search'}
                        border="1px solid #eee"
                        ml={1}
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </InputGroup>
                <Box maxH="200px">
                    {filteredOptions?.map((option) => (
                        <Box padding="6px 12px" color="#000" key={option.id} onClick={() => handleChange(option)}>
                            {option.name}
                        </Box>
                    ))}
                </Box>
            </MenuList>
        </Menu>
    );
};

export default CustomDropboxRenderer;
